export default "__VITE_ASSET__BmeF1v6f__"